import CustomButton from "../../components/Button";
import AddOrderIcon from "../../assets/Order/AddOrder.svg";
import BlukOrderIcon from "../../assets/Order/BlukOrderIcon.svg";
import { OrderStatus } from "./OrderStatus";
import DeliveryGIF from "../../assets/OrderCard/Gif.png";
import { CustomTable } from "../../components/Table";
import { useEffect, useState } from "react";
import Stepper from "./Stepper";
import "../../styles/silkStyle.css";
import DeliveryIcon from "../../assets/Delivery.svg";
import {
  columnHelperForNewOrder,
  ColumnHelperForBookedAndReadyToPicked,
  columnHelpersForRest,
} from "./ColumnHelpers";
import { useMediaQuery } from "react-responsive";
import { ResponsiveState } from "../../utils/responsiveState";
import { POST } from "../../utils/webService";
import {
  CANCEL_TEMP_SELLER_ORDER,
  CANCEL_WAY_BILL,
  COMPANY_NAME,
  GET_SELLER_ORDER,
  SELLER_WEB_URL,
} from "../../utils/ApiUrls";

import trackingIcon from "../../assets/trackingShipyaariIcon.jpg";
import trackingIcon2 from "../../assets/trackingShipyaari2.svg";
import instagramIcon from "../../assets/instagramIcon.svg";
import facebook from "../../assets/facebookIcon.svg";
import Star from "../../assets/Comments.svg";
import bookedIcon from "../../assets/Transaction/bookedIcon.svg";
import DelhiveryIcon from "../../assets/Delhivery_Logo_(2019) 2.svg";
import telephoneIcon from "../../assets/telephoneIcon.svg";
import TrackingMenu from "../../assets/trackingMenu.svg";
import DownwardArrow from "../../assets/downwardArrow.svg";
import UpwardArrow from "../../assets/AccordionUp.svg";
import Product from "../../assets/layer.svg";
import GalleryIcon from "../../assets/galleryIcon.svg";

import redirectIcon from "../../assets/redirect.svg";
import MoreIcon from "../../assets/more.svg";
import DimensionIcon from "../../assets/3d-cube-scan.svg";
import SkuBoxIcon from "../../assets/DeliveryOder.svg";
import BoxSearchIcon from "../../assets/box-search.svg";
import orderBox from "../../assets/Delivery Icon.svg";
import DelivertTruckIcon from "../../assets/DeliveryTruckIcon.svg";
import Location from "../../assets/Location.svg";
import TaskSquare from "../../assets/task-square.svg";
import profileIcon from "../../assets/Contact.svg";
import TelePhoneIcon from "../../assets/telephoneIcon.svg";
import ShareIcon from "../../assets/16.svg";
import TickLogo from "../../assets/tick.gif";
import { Tooltip } from "react-tooltip";
import { capitalizeFirstLetter } from "../../utils/utility";
import { date_DD_MMM, date_DD_MMM_YYYY_HH_MM } from "../../utils/dateFormater";
import { Tooltip as CustomToolTip } from "../../components/Tooltip/Tooltip";
import blueCar from "../../assets/blueCar.svg";
import infoRedCircleIcon from "../../assets/info-circle-outline.svg";
import InformativeIcon from "../../assets/I icon.svg";

function OrderCard({
  data,
  currentStatus,
  orderActions,
  setInfoModalContentFunction,
}: any) {
  const { status, codInfo, boxInfo, service, pickupAddress, deliveryAddress } =
    data;

  const normalizedCurrentStatus =
    currentStatus === "READY TO PICK" ? "READY TO PICKUP" : currentStatus;
  const fallbackLatestStatus =
    status?.[status?.length - 1]?.currentStatus || "DRAFT";
  const fallbackLatestStatusTimeStamp = status?.[status?.length - 1]?.timeStamp;
  const displayStatus = normalizedCurrentStatus || fallbackLatestStatus;
  const displayStatusEntry = status?.find(
    (item: any) =>
      item?.currentStatus === normalizedCurrentStatus ||
      item?.currentStatus === currentStatus
  );
  const displayStatusTimeStamp =
    displayStatusEntry?.timeStamp || fallbackLatestStatusTimeStamp;

  const [openSection, setOpenSection] = useState<any>(false);
  const [cartData, setcartData] = useState<any>({
    latestStatus: "",
    statusTimeStamp: 0,
  });

  const statusTime: any = {
    DRAFT: { title: "Order Placed :" },
    BOOKED: { title: "Pick Up Expected :" },
    "READY TO PICKUP": { title: "Pick Up Expected :" },
    "PICKED UP": { title: "ETA" },
    "IN TRANSIT": { title: "ETA" },
    "OUT FOR DELIVERY": { title: "ETA" },
    DELIVERED: { title: "ETA" },
    CANCELLED: { title: "ETA", icon: "blueCar" },
  };

  const getStatusTimeStampTitle = () => {};

  const steps = [
    {
      label: "Picked",
      isCompleted: true,
      isActive: false,
      imgSrc: TickLogo,
      timeStatus: "03 Jun ",
    },
    {
      label: "In Transit",
      isCompleted: false,
      isActive: true,
      imgSrc: TickLogo,
      timeStatus: "01 Jun | 16:32:46",
    },
    {
      label: "Out For Delivery",
      isCompleted: false,
      isActive: false,
      imgSrc: TickLogo,
      timeStatus: "",
    },
    {
      label: "Delivered",
      isCompleted: false,
      isActive: false,
      imgSrc: TickLogo,
      timeStatus: "",
    },
  ];

  const moreDropDown = (
    currentStatus?: any,
    orderActions?: any,
    data?: any
  ) => {
    const normalizedActionStatus =
      currentStatus === "READY TO PICKUP"
        ? "READY TO PICK"
        : currentStatus === "OUT FOR DELIVERY"
          ? "OUT OF DELIVERY"
          : currentStatus;
    let payLoad: any;
    let fileUrl: any;

    if (normalizedActionStatus === "DRAFT") {
      const { orderId, tempOrderId, sellerId } = data;
      payLoad = {
        tempOrderIdArray: [tempOrderId],
      };
    } else if (
      [
        "BOOKED",
        "CANCELLED",
        "PICKED UP",
        "IN TRANSIT",
        "OUT OF DELIVERY",
        "OUT FOR DELIVERY",
        "DELIVERED",
        "RETURN",
        "LOST_AND_DAMAGE",
        "EXCEPTION",
        "READY TO PICK",
        "READY TO PICKUP",
      ].includes(normalizedActionStatus)
    ) {
      const labelUrl = data?.boxInfo?.[0]?.tracking?.label;

      const taxInvoiceUrl = data?.boxInfo?.[0]?.tracking?.taxInvoice;

      fileUrl = labelUrl || "";
      payLoad = {
        awbs: [data?.awb],
        fileUrl: labelUrl,
        taxInvoiceUrl: taxInvoiceUrl,
      };
    }

    const actionsObject: any = {
      DRAFT: [
        { title: "Delete Order", actionType: "delete" },
        { title: "Duplicate Order", actionType: "duplicate_order" },
      ],
      BOOKED: [
        { title: "Track Order", actionType: "track_order" },
        { title: "Download Label", actionType: "download_label" },
        { title: "Download Invoice", actionType: "download_invoice" },
        { title: "Cancel Order", actionType: "cancel_order" },
      ],
      CANCELLED: [
        { title: "Track Order", actionType: "track_order" },
        { title: "Download Label", actionType: "download_label" },
        { title: "Download Invoice", actionType: "download_invoice" },
      ],
      "PICKED UP": [
        { title: "Track Order", actionType: "track_order" },
        { title: "Download Label", actionType: "download_label" },
        { title: "Download Invoice", actionType: "download_invoice" },
      ],
      "IN TRANSIT": [
        { title: "Track Order", actionType: "track_order" },
        { title: "Download Label", actionType: "download_label" },
        { title: "Download Invoice", actionType: "download_invoice" },
      ],
      EXCEPTION: [
        { title: "Track Order", actionType: "track_order" },
        { title: "Download Label", actionType: "download_label" },
        { title: "Download Invoice", actionType: "download_invoice" },
      ],
      "OUT OF DELIVERY": [
        { title: "Track Order", actionType: "track_order" },
        { title: "Download Label", actionType: "download_label" },
        { title: "Download Invoice", actionType: "download_invoice" },
      ],
      DELIVERED: [
        { title: "Track Order", actionType: "track_order" },
        { title: "Download Label", actionType: "download_label" },
        { title: "Download Invoice", actionType: "download_invoice" },
      ],
      RETURN: [
        { title: "Track Order", actionType: "track_order" },
        { title: "Download Label", actionType: "download_label" },
        { title: "Download Invoice", actionType: "download_invoice" },
      ],
      LOST_AND_DAMAGE: [
        { title: "Track Order", actionType: "track_order" },
        { title: "Download Label", actionType: "download_label" },
        { title: "Download Invoice", actionType: "download_invoice" },
      ],
    };

    const actionClickHandler = (
      payLoad?: any,
      actionType?: any,
      currentStatus?: any,
      data?: any
    ) => {
      if (actionType === "track_order") {
        window.open(
          `${SELLER_WEB_URL}/tracking?trackingNo=${data?.awb}`,
          "_blank"
        );
      } else {
        orderActions(payLoad, actionType, currentStatus, data);
      }
    };

    //bg-[#E5E7EB]

    return (
      <div className=" min-w-[150px] rounded-md ">
        {actionsObject[normalizedActionStatus]?.map((action: any, index: any) => (
          <>
            {action?.actionType === "download_label" ? (
              <div
                className=" text-[14px] flex p-3 items-center"
                key={`${index}_${action}`}
                onClick={() =>
                  actionClickHandler(
                    payLoad,
                    action.actionType,
                    normalizedActionStatus,
                    data
                  )
                }
              >
                {fileUrl !== "" ? action?.title : "Download Label"}
              </div>
            ) : (
              <div
                className="text-[14px] flex p-3 items-center"
                key={`${index}_${action}`}
                onClick={() =>
                  actionClickHandler(
                    payLoad,
                    action.actionType,
                    normalizedActionStatus,
                    data
                  )
                }
              >
                {action?.title}
              </div>
            )}
          </>
        ))}
      </div>
    );
  };

  const handleInformativeModal = () => {
    if (!setInfoModalContentFunction) return;
    const awb = data?.awb;
    const tempOrderId = data?.tempOrderId;
    setInfoModalContentFunction({
      awb,
      // `CustomTableAccordian` fetch expects `orderId` like "T<tempOrderId>" so it can derive `tempOrderId`.
      // Some draft cards have a non-T `orderId` string; always send the T-prefixed tempOrderId for consistency.
      orderId: tempOrderId ? `T${tempOrderId}` : data?.orderId,
      tempOrderId,
      orderNumber: data?.otherDetails?.orderNumber,
    });
  };

  useEffect(() => {
    const bookedStatus = status?.find(
      (s: any) => s?.currentStatus === "BOOKED"
    );
    setcartData({
      status: {
        latestStatus: status?.[status?.length - 1]?.currentStatus || "DRAFT",
        statusTimeStamp: status?.[data?.status?.length - 1]?.timeStamp,
        note: status?.[data?.status?.length - 1]?.notes,
      },
      invoiceValue: codInfo?.invoiceValue,
      codAmount: codInfo?.collectableAmount,
      paymentType: codInfo ? (codInfo?.isCod ? "COD" : "PREPAID") : "-",
      productName: boxInfo?.[0]?.products.map((data: any) => data.name),
      awb: data?.awb,
      dimensions: `${boxInfo?.[0]?.length}cm  X  ${boxInfo?.[0]?.breadth}cm  X  ${boxInfo?.[0]?.height}cm`,
      shipyaariId: data?.tempOrderId,
      orderId: data?.orderId,
      source: data?.source,
      orderType: data?.orderType,
      createdAt: data?.createdAt,
      bookedAt: bookedStatus?.timeStamp,
      updatedAt:
        data?.updatedAt ||
        data?.lastUpdatedAt ||
        data?.modifiedAt ||
        data?.createdAt,
      partnerName: service?.partnerName,
      pickupAddress: pickupAddress?.fullAddress,
      deliveryAddress: deliveryAddress?.fullAddress,
    });
  }, [data]);

  const formatPrice = (value: any) => {
    if (value === null || value === undefined || value === "") return "-";
    const n = typeof value === "number" ? value : Number(value);
    if (Number.isFinite(n)) return n.toFixed(2);
    return String(value);
  };

  return (
    <div className="my-8 ">
      <div className="shadow-md border-[0.5px] border-[#e9e8e8] rounded-lg">
        <div className="relative py-4 px-3 rounded-lg">
          <div
            className={`absolute top-[-15px] left-6 inline-flex items-center justify-center gap-x-1 rounded-md ${
              displayStatus === "FAILED"
                ? " bg-[#FEEEEB] border-[0.5px] border-[#F35838]"
                : " bg-[#F2FAEF] border-[0.5px] border-[#9af17d]"
            }  px-3 py-[6px]`}
          >
            <img
              src={
                displayStatus === "FAILED"
                  ? infoRedCircleIcon
                  : bookedIcon
              }
              alt=""
              className="w-4"
            />
            <span
              className={`text-xs font-semibold rounded ${
                displayStatus === "FAILED"
                  ? "text-[#F35838]"
                  : "text-[#7CCA62]"
              } text-[#7CCA62] items-center`}
            >
              {capitalizeFirstLetter(displayStatus)}
            </span>
          </div>

          <div className="">
            <div className="mt-3 mb-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-3">
              <div className="text-[#004EFF] flex items-center text-[12px] min-w-0">
                {displayStatus === "CANCELLED" && (
                  <img src={blueCar} alt="" className="mr-2 w-[22px]" />
                )}
                <div className="flex items-center text-[14px] min-w-0 whitespace-nowrap overflow-hidden text-ellipsis">
                  <span className="mr-1 flex-shrink-0">
                    {statusTime[displayStatus]?.title}{" "}
                  </span>
                  <span className="truncate">
                    {date_DD_MMM(
                      displayStatusTimeStamp ? displayStatusTimeStamp : 1700830030191
                    )}
                  </span>
                </div>
                {setInfoModalContentFunction && (
                  <button
                    type="button"
                    className="ml-2 inline-flex items-center justify-center"
                    onClick={handleInformativeModal}
                    aria-label="Open order details"
                  >
                    <img src={InformativeIcon} alt="" className="w-[18px]" />
                  </button>
                )}
              </div>

              <div className="flex items-center justify-between sm:justify-end text-[14px] gap-2 flex-shrink-0 min-w-0 w-full sm:w-auto sm:min-w-[210px]">
                <div
                  className="w-[92px] text-right tabular-nums truncate"
                  title={`₹ ${cartData?.invoiceValue ?? "-"}`}
                  data-tooltip-id={`order-card-price-${cartData?.awb || cartData?.shipyaariId || cartData?.orderId || "na"}`}
                  data-tooltip-content={`₹ ${cartData?.invoiceValue ?? "-"}`}
                >
                  ₹ {formatPrice(cartData?.invoiceValue)}
                </div>
                <Tooltip
                  id={`order-card-price-${cartData?.awb || cartData?.shipyaariId || cartData?.orderId || "na"}`}
                  style={{
                    backgroundColor: "bg-neutral-900",
                    color: "#FFFFFF",
                    fontSize: "14px",
                    lineHeight: "16px",
                    border: "1px solid white",
                    width: "max-w-[100%]",
                  }}
                />
                <div className="text-[#004EFF] flex-shrink-0">
                  <span>
                    {cartData?.paymentType}
                  </span>
                </div>
                <div
                  className="cursor-pointer flex-shrink-0"
                  onClick={() => setOpenSection((v: boolean) => !v)}
                >
                  <img
                    src={openSection ? UpwardArrow : DownwardArrow}
                    alt=""
                    data-tooltip-id="my-order-inline"
                    data-tooltip-content={
                      openSection
                        ? "Expand the order to view details of the order"
                        : ""
                    }
                  />

                  <Tooltip
                    id="my-order-inline"
                    style={{
                      backgroundColor: "bg-neutral-900",
                      color: "#FFFFFF",
                      // width: "fit-content",
                      fontSize: "14px",
                      lineHeight: "16px",
                      border: "1px solid white",
                      width: "max-w-[100%]",
                    }}
                  />
                </div>
                <div className="cursor-pointer flex-shrink-0">
                  <CustomToolTip
                    position="left"
                    content={moreDropDown(currentStatus, orderActions, data)}
                    showOnClick={true}
                    bgColor="bg-white"
                    textColor="black"
                  >
                    <div className="cursor-pointer">
                      <img
                        src={MoreIcon}
                        alt="moreIcon"
                        className="hover:-translate-y-[0.1rem] hover:scale-110 duration-300"
                      />
                    </div>
                  </CustomToolTip>
                </div>
              </div>
            </div>

            <div>
              <div className={`${!cartData?.awb && "flex justify-between"} `}>
                <div className="text-[13px] font-medium">
                  {cartData?.productName?.join(" + ").toUpperCase()}
                </div>

                {cartData?.awb && (
                  <div
                    className={`text-[14px] my-1 flex ${
                      cartData?.awb && "flex justify-between"
                    } `}
                  >
                    <div>Tracking : {cartData?.awb}</div>
                    <div
                      className={`flex`}
                      onClick={() =>
                        window.open(
                          `${SELLER_WEB_URL}/tracking?trackingNo=${cartData?.awb}`,
                          "_blank"
                        )
                      }
                    >
                      <img src={redirectIcon} alt="" />
                    </div>
                  </div>
                )}

              </div>

              {/* Always-visible compact details (mobile-friendly) */}
              <div className="mt-2 grid grid-cols-1 gap-x-3 gap-y-1 text-[12px] text-[#323232] sm:grid-cols-2">
                <div className="min-w-0 flex items-center gap-1">
                  <span className="text-[#777777] whitespace-nowrap">
                    {COMPANY_NAME} ID:
                  </span>
                  <span
                    className="min-w-0 truncate"
                    title={cartData?.shipyaariId || "-"}
                  >
                    {cartData?.shipyaariId || "-"}
                  </span>
                </div>
                <div className="min-w-0 flex items-center gap-1">
                  <span className="text-[#777777] whitespace-nowrap">
                    Order ID:
                  </span>
                  <span
                    className="min-w-0 truncate"
                    title={cartData?.orderId || "-"}
                  >
                    {cartData?.orderId || "-"}
                  </span>
                </div>
                <div className="min-w-0 flex items-center gap-1">
                  <span className="text-[#777777] whitespace-nowrap">
                    Delivery Partner:
                  </span>
                  <span
                    className="min-w-0 truncate"
                    title={cartData?.partnerName || "-"}
                  >
                    {cartData?.partnerName || "-"}
                  </span>
                </div>
                <div className="min-w-0 flex items-center gap-1">
                  <span className="text-[#777777] whitespace-nowrap">
                    Source:
                  </span>
                  <span
                    className="min-w-0 truncate"
                    title={cartData?.source || "-"}
                  >
                    {cartData?.source || "-"}
                  </span>
                </div>
                <div className="min-w-0 flex items-center gap-1">
                  <span className="text-[#777777] whitespace-nowrap">
                    Order Type:
                  </span>
                  <span
                    className="min-w-0 truncate"
                    title={cartData?.orderType || "-"}
                  >
                    {cartData?.orderType || "-"}
                  </span>
                </div>
                <div className="min-w-0 flex items-center gap-1">
                  <span className="text-[#777777] whitespace-nowrap">
                    Booked At:
                  </span>
                  <span
                    className="min-w-0 truncate"
                    title={
                      cartData?.bookedAt
                        ? date_DD_MMM_YYYY_HH_MM(cartData.bookedAt)
                        : "-"
                    }
                  >
                    {cartData?.bookedAt
                      ? date_DD_MMM_YYYY_HH_MM(cartData.bookedAt)
                      : "-"}
                  </span>
                </div>
                <div className="min-w-0 flex items-center gap-1">
                  <span className="text-[#777777] whitespace-nowrap">
                    Created At:
                  </span>
                  <span
                    className="min-w-0 truncate"
                    title={
                      cartData?.createdAt
                        ? date_DD_MMM_YYYY_HH_MM(cartData.createdAt)
                        : "-"
                    }
                  >
                    {cartData?.createdAt
                      ? date_DD_MMM_YYYY_HH_MM(cartData.createdAt)
                      : "-"}
                  </span>
                </div>
              </div>

              {openSection && (
                <>
                  {/* Expanded: full details */}
                  <div className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1 text-[12px] text-[#323232]">
                    <div className="min-w-0">
                      <span className="text-[#777777]">Source:</span>{" "}
                      <span className="break-words">{cartData?.source || "-"}</span>
                    </div>
                    <div className="min-w-0">
                      <span className="text-[#777777]">Order Type:</span>{" "}
                      <span>{cartData?.orderType || "-"}</span>
                    </div>
                    <div className="min-w-0">
                      <span className="text-[#777777]">COD Amount:</span>{" "}
                      <span>₹ {cartData?.codAmount ?? "-"}</span>
                    </div>
                    <div className="min-w-0">
                      <span className="text-[#777777]">Updated:</span>{" "}
                      <span className="break-words">
                        {cartData?.updatedAt ? date_DD_MMM(cartData.updatedAt) : "-"}
                      </span>
                    </div>
                    <div className="col-span-2 min-w-0">
                      <span className="text-[#777777]">Pickup:</span>{" "}
                      <span className="break-words">{cartData?.pickupAddress || "-"}</span>
                    </div>
                    <div className="col-span-2 min-w-0">
                      <span className="text-[#777777]">Delivery:</span>{" "}
                      <span className="break-words">{cartData?.deliveryAddress || "-"}</span>
                    </div>
                  </div>
                </>
              )}

              {openSection && (
                <>
                  {/* {(cartData?.latestStatus === "BOOKED" ||
                    "IN TRANSIT" ||
                    "DELIVERED") && (
                    <div className="mt-4">
                      <Stepper steps={steps} />
                    </div>
                  )} */}

                  {cartData?.status?.latestStatus === "FAILED" && (
                    <div className="mt-2">
                      <div className="flex items-center text-[16px]">
                        <img src={TaskSquare} alt="" className="w-[18px]" />
                        <div className="ml-2">Reason</div>
                      </div>
                      <div className="mt-2 text-[13px]">
                        <div className="ml-6">{cartData?.status?.note}</div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderCard;
